import React from 'react';
import {
  Stack,
  Button,
  Text,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  UserRoundIcon,
  UserAccountIcon
} from '@quotient/riq-react-ui';
import { AppContext } from '@quotient/riq-state';
import { signOut } from '../api';

interface INavbarProps {}

const styles = {
  userMenu: {
    fontSize: [2, 3],
    position: ['absolute', 'initial'],
    top: '10px',
    right: '0',
    zIndex: '10000'
  },
  userMenuLink: {
    marginLeft: '10px',
    marginTop: '3px',
    color: 'grays.500'
  }
};

function Navbar(props: INavbarProps) {
  const { appState }: any = React.useContext(AppContext);
  const { isUserLoggedIn, signinlink, firstName } = appState?.getCommonData?.CI_SigninSignupLinks || {};

  return React.useMemo(
    () => (
      <Stack align="center" justify="space-between">
        <Stack gap={2}>
          <Button {...{ href: '/coupons' }} as="a" variant="primary">
            Coupons
          </Button>
          <Button {...{ href: '/weeklyad' }} as="a" variant="primary">
            Weekly Ads
          </Button>
          {isUserLoggedIn === 1 && (
            <Button {...{ href: '/settings' }} as="a" variant="primary">
              My Account
            </Button>
          )}
        </Stack>
        <Stack gap={2}>
          {isUserLoggedIn && firstName ? (
            <Menu>
              <MenuButton css={styles.userMenu} as={Button} variant="plain">
                <UserRoundIcon />
                <Stack css={{ marginLeft: '10px' }}>
                  <Text css={{ display: 'inline-block', marginTop: '7px' }}>Hi, {firstName}</Text>
                  <span style={{ padding: '4px' }}>
                    <svg width="10px" height="6px">
                      <polygon fill="currentColor" points="0,0 10,0 5, 6" />
                    </svg>
                  </span>
                </Stack>
              </MenuButton>
              <MenuList>
                <Stack
                  direction={'vertical'}
                  css={{
                    width: '230px',
                    height: '120px',
                    color: 'grays.600'
                  }}
                >
                  <MenuItem style={{ borderBottom: '1px solid #dedede' }}>
                    <Button
                      css={{ fontSize: [2, 4], height: '60px', paddingY: 4, paddingX: 8 }}
                      onClick={() => {
                        window.location.href = '/settings/';
                      }}
                      variant="plain"
                    >
                      <UserAccountIcon style={{ marginRight: '10px' }}></UserAccountIcon>
                      My Account
                    </Button>
                  </MenuItem>
                  <MenuItem>
                    <Button
                      onClick={signOut}
                      css={{ fontSize: [2, 3], height: '60px', paddingY: 4, paddingX: 8 }}
                      variant="plain"
                    >
                      Sign Out
                    </Button>
                  </MenuItem>
                </Stack>
              </MenuList>
            </Menu>
          ) : (
            <Stack css={styles.userMenu}>
              <UserRoundIcon />
              <Link size={4} href={signinlink} css={styles.userMenuLink}>
                Sign in here
              </Link>
            </Stack>
          )}
        </Stack>
      </Stack>
    ),
    [isUserLoggedIn, signinlink, firstName]
  );
}

export default Navbar;
